import { useState, useEffect } from 'react';
import Router from 'next/router';
import * as Sentry from '@sentry/browser';

import AwsAuth from '@aws-amplify/auth';
import { tokenExpired, isCoveToken } from '@covexl/cove-api-client';

import logger from 'utilities/logger';

import CoveApi from 'utilities/coveApi2';

const TokenApi = CoveApi('Token');

export default function useTokenRefresh() {
  const [tokenBroken, setTokenBroken] = useState(false);
  const [ready, setReady] = useState(false); // Indicates refresh complete
  useEffect(() => {
    const run = async () => {
      const webId = localStorage.getItem('cove-web-id');
      const accessToken = localStorage.getItem('cove-access-token');

      try {
        if (accessToken) {
          if (tokenExpired(accessToken)) {
            let newAccessToken;

            // check for cognito token
            if (!isCoveToken(accessToken)) {
              const session = await AwsAuth.currentSession();
              newAccessToken = session.getAccessToken().getJwtToken();
            } else {
              if (!webId) {
                logger.info('Token Refresh', 'Token is broken no web id');
                return setTokenBroken(true);
              } else {
                newAccessToken = await TokenApi.refresh(accessToken, { web_id: webId });
              }
            }

            localStorage.setItem('cove-access-token', newAccessToken);
            setTokenBroken(false);
          }
        } else {
          // automatically reroute to the landing page
          localStorage.removeItem('cove-web-id');
          setTokenBroken(false);
        }
      } catch (err) {
        logger.info('Token Refresh', 'Token is broken', err);
        setTokenBroken(true);
        localStorage.removeItem('cove-access-token'); // delete token so it won't break everything

        Sentry.withScope(function(scope) {
          scope.setExtra('error', err);
          Sentry.captureException(new Error('Refresh token error'));
        });
      }
      setReady(true); // Signal that refresh (successful or not) is complete
    };

    run();
  }, []);

  return { tokenBroken, ready };
}
